import { DdpImage } from "@/components/shared/DdpImage"
import { TDdpMedia } from "@/shared/types"

export function SeventhSection(props: Array<{
    imageBig: Array<TDdpMedia>
    imageSmall: Array<TDdpMedia>
    text: string
}>) {
    const { imageBig, imageSmall, text } = props[0]
    return (
        <div className="landing-seventh-section">
            <div className="images-wrapper">
                <div className="image-big">
                    <DdpImage image={imageBig[0]} />
                </div>
                <div className="image-small">
                    <div className="text sm:hidden tmd:block" dangerouslySetInnerHTML={{ __html: text }} />
                    <DdpImage image={imageSmall[0]} />
                </div>
            </div>
            <div className="text tmd:hidden" dangerouslySetInnerHTML={{ __html: text }} />
        </div>
    );
}